export default __webpack_public_path__ + "static/media/user-upload-image.989d14f5.jpeg";